<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'

export default {
  data() {
    return {
      locale: zhCN,
    }
  },
  mounted() {
    const intaFontSize = (win, doc) => {
      function setFontSize() {
        const winWidth = window.innerWidth
        doc.documentElement.style.fontSize = `${(winWidth / 375) * 100}px`
      }
      const evt = 'onorientationchange' in win ? 'orientationchange' : 'resize'
      let timer = null
      win.addEventListener(
        evt,
        function () {
          clearTimeout(timer)
          timer = setTimeout(setFontSize, 300)
        },
        false
      )
      win.addEventListener(
        'pageshow',
        function (e) {
          if (e.persisted) {
            clearTimeout(timer)
            timer = setTimeout(setFontSize, 300)
          }
        },
        false
      ) //初始化
      setFontSize()
    }
    intaFontSize(window, document)
  },
}
</script>
<style>
#app {
  height: 100%;
}
</style>
